import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { Input } from 'antd';

const formatLabel = (price, currency = 'USD', language = 'en') => {
  if (language) {
    return price.toLocaleString(language, { style: 'currency', currency });
  }
  return price;
};

const CustomInput = styled(Input)`
  min-width: 60px;
`;
const FormulaContainer = styled.div`
  display: flex;
  flex-direction: row;
  font-size: ${({ theme }) => theme.fontSize.medium};
  margin-bottom: 42px;
  width: 400px;
`;

const FormulaCell = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  flex-basis: 70px;
`;

const CellLabel = styled.span`
  font-size: ${({ theme }) => theme.fontSize.small};
`;

const ProfitFormula = ({ data, intl, currentLanguage, editable }) => {
  const {
    salePrice,
    setSalePrice,
    activeSourcePrice,
    setManualTotalPrice,
    autoPurchaseFee,
    ebayFee,
    setEbayFee,
    paypalFee,
    setPaypalFee,
    shippingCollected,
    setShippingCollected,
    profit,
    currency,
  } = data;
  return (
    <FormulaContainer>
      <FormulaCell>
        {editable ? (
          <CustomInput value={salePrice} onChange={setSalePrice} />
        ) : (
          <span>{formatLabel(salePrice, currency, currentLanguage)}</span>
        )}
        <CellLabel>{intl.formatMessage({ id: 'orders.salePrice' })}</CellLabel>
      </FormulaCell>
      <FormulaCell>+</FormulaCell>
      <FormulaCell>
        {editable ? (
          <CustomInput value={shippingCollected} onChange={setShippingCollected} />
        ) : (
          <span>{formatLabel(shippingCollected, currency, currentLanguage)}</span>
        )}
        <CellLabel>{intl.formatMessage({ id: 'orders.shippingCollected' })}</CellLabel>
      </FormulaCell>
      <FormulaCell>-</FormulaCell>
      <FormulaCell>(</FormulaCell>
      <FormulaCell>
        {editable ? (
          <CustomInput defaultValue={activeSourcePrice} onChange={setManualTotalPrice} />
        ) : (
          <span>{formatLabel(activeSourcePrice, currency, currentLanguage)}</span>
        )}
        <CellLabel>Total Price</CellLabel>
      </FormulaCell>
      <FormulaCell>+</FormulaCell>
      <FormulaCell>
        <span>{formatLabel(autoPurchaseFee, currency, currentLanguage)}</span>
        <CellLabel>TM Fee</CellLabel>
      </FormulaCell>
      <FormulaCell>+</FormulaCell>
      <FormulaCell>
        <span>{formatLabel(shippingCollected, currency, currentLanguage)}</span>
        <CellLabel>{intl.formatMessage({ id: 'orders.shippingCost' })}</CellLabel>
      </FormulaCell>
      <FormulaCell>)</FormulaCell>
      <FormulaCell>-</FormulaCell>
      <FormulaCell>(</FormulaCell>
      <FormulaCell>
        {editable ? (
          <CustomInput value={ebayFee} onChange={setEbayFee} />
        ) : (
          <span>{formatLabel(ebayFee, currency, currentLanguage)}</span>
        )}
        <CellLabel>{intl.formatMessage({ id: 'orders.ebayFees' })}</CellLabel>
      </FormulaCell>
      <FormulaCell>+</FormulaCell>
      <FormulaCell>
        {editable ? (
          <CustomInput value={paypalFee} onChange={setPaypalFee} />
        ) : (
          <span>{formatLabel(paypalFee, currency, currentLanguage)}</span>
        )}
        <CellLabel>{intl.formatMessage({ id: 'orders.paymentFee' })}</CellLabel>
      </FormulaCell>
      <FormulaCell>)</FormulaCell>
      <FormulaCell>=</FormulaCell>
      <FormulaCell>
        <span>{formatLabel(profit, currency, currentLanguage)}</span>
        <CellLabel>{intl.formatMessage({ id: 'common.profit' })}</CellLabel>
      </FormulaCell>
    </FormulaContainer>
  );
};

ProfitFormula.propTypes = {
  data: PropTypes.object.isRequired,
  intl: PropTypes.object,
  currentLanguage: PropTypes.string,
  editable: PropTypes.bool,
};

export default observer(ProfitFormula);
